import {Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {BsDropdownDirective} from 'ngx-bootstrap/dropdown';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-breadcrums',
  templateUrl: './breadcrums.component.html',
  styleUrls: ['./breadcrums.component.scss']
})
export class BreadcrumsComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  @Input() filterVue: string;
  @Input() filterValue: string;
  @Input() filterPlaceholder: string;
  // tslint:disable-next-line:no-any
  @Input() list: Observable <any[]>;
  // tslint:disable-next-line:no-any
  @Output() redirectList = new EventEmitter<any>();
  // tslint:disable-next-line:no-any
  @Output() redirectName = new EventEmitter<any>();
  selected: string;
  // @ViewChild('dropdown', {read: BsDropdownDirective}) dropdown: BsDropdownDirective;
  // @ViewChild('dropdownToggle', {read: ElementRef}) dropdownToggle: ElementRef;
  // @ViewChild('dropdownFilter', {read: ElementRef}) dropdownFilter: ElementRef;

  @ViewChild('dropdown', {static: false , read: BsDropdownDirective}) dropdown: BsDropdownDirective;
  @ViewChild('dropdownToggle', {static: false , read: ElementRef}) dropdownToggle: ElementRef;
  @ViewChild('dropdownFilter', {static: false , read: ElementRef }) dropdownFilter: ElementRef;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: MouseEvent): void {
    if (this.dropdown &&
      this.dropdown.isOpen &&
      $event.button !== 2 &&
      !this.dropdownToggle.nativeElement.contains($event.target) &&
      !this.dropdownFilter.nativeElement.contains($event.target)) {
      this.dropdown.hide();
    }
  }

  @HostListener('keyup.esc')
  onEsc(): void {
    if (this.dropdown && this.dropdown.isOpen) {
      this.dropdown.hide();
    }
  }

  onShown(): void {
    // if (this.dropdownFilter) {
      setTimeout(() => this.dropdownFilter.nativeElement.focus(), 100);
   // }
  }

  noResult(result: boolean): void {
    // if (result && this.selected && this.group.get(this.config.controlName[0]).value.length) {
    //   this.group.get(this.config.controlName[0]).patchValue(this.group.get(this.config.controlName[0]).value.slice(0, -1))
    // }
  }
  /* tslint:disable */
  public typeaheadOnSelect(e: any): void {
   this.redirectList.emit(e.item[this.filterValue]);
  }
  public nameClickSelect(): void {
    this.redirectName.emit();
  }

}
